import styled from 'styled-components';

export const SecondaryButton = styled.button`
    background-color: #051923;
    color: #fff;
    padding: 0.5rem 1.5rem;
    border: none;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.3s ease;
    font-family: 'Outfit';
    font-weight: 600;
    display: inline-block;
    line-height: 1.5;
    border-radius: 5px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.7);
    text-decoration: none;
`;

export const SectionContainer = styled.div`
    position: relative;
    width: 100%;
    height: 40vh;
    background-image: url(/assets/background-industry.png);
    background-size: 25rem;
    background-position: right bottom;
    background-repeat: no-repeat;
    height: auto;
    padding: 80px;
    background-color: #F9F9F9;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    a {
        background-color: #051923;
        color: #fff;
        padding: 0.5rem 1.5rem;
        border: none;
        font-size: 1rem;
        cursor: pointer;
        transition: background-color 0.3s ease;
        font-family: 'Outfit';
        font-weight: 600;
        display: inline-block;
        line-height: 1.5;
        border-radius: 5px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.7);
        text-decoration: none;
        margin-top: 3rem;
    }

    p {
        font-family: 'Outfit';
        line-height: 2;
        font-size: 1rem;
        color: #212121;
        text-align: left;
        margin-top: 3rem;
        margin-bottom: 2rem;
        max-width: 1080px;
    }

    .prompt-example {
        bottom: 0;
        right: 150px;
        font-family: 'M Plus Code Latin';
        font-size: 0.8rem;
        border-left: 3px solid #FC7F03;
        line-height: 1.5;
        text-align: left;
        padding: 0.5rem 1rem;
        color: #333333;
        max-width: 600px;
        background-color: #FFF6EE;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }

    a {
        background-color: #051923;
        color: #fff;
        padding: 0.5rem 1.5rem;
        border: none;
        font-size: 1rem;
        cursor: pointer;
        transition: background-color 0.3s ease;
        font-family: 'Outfit';
        font-weight: 600;
        display: inline-block;
        line-height: 1.5;
        border-radius: 5px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.7);
        text-decoration: none;
        margin-top: 3rem;
    }

    &.align-right {
        align-items: flex-end;
        text-align: right;
    }
`;

export const SectionContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;

    h2 {
        font-family: 'Outfit';
        font-size: 1.2rem;
        color: #212121;
        font-weight: 500;
        margin-top: 0.5rem;
        margin-bottom: 0;
        width: 100%;
    }

    p {
        font-family: 'Outfit';
        line-height: 2;
        font-size: 1rem;
        color: #212121;
        margin-top: 1rem;
        margin-bottom: 2rem;
        max-width: 1080px;
        width: 100%;
    }

    em {
        font-style: normal;
        font-weight: 600;
    }

    ul {
        margin: 0;
        padding-left: 1rem;
        width: 100%;
        box-sizing: border-box;

        em {
            margin-right: 0.2rem;
        }
    }

    .prompt-example {
        bottom: 0;
        right: 150px;
        font-family: 'M Plus Code Latin';
        font-size: 0.8rem;
        border-left: 3px solid #1C4294;
        line-height: 1.5;
        text-align: left;
        padding: 0.5rem 1rem;
        color: #333333;
        max-width: 600px;
        background-color: #E1ECFF;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
`;

export const SectionIntro = styled.p`
    text-align: center;
    width: 100%;
    margin-top: 1.5rem;
    margin-bottom: 3rem;
    max-width: 1080px;
    font-size: 1.5rem;
    font-weight: 500;
    font-family: 'Outfit';
    line-height: 1.5;
    color: #212121;
`;

export const SupplyChainContainer = styled(SectionContainer)`
    background-image: url(/assets/robot-supply-chain.png);
    background-position: left bottom;

    .prompt-example {
        border-left: none;
        border-right: 3px solid #A56BAA;
        background-color: #FDEBFF;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
`

export const SupportContainer = styled(SectionContainer)`
    background-image: url(/assets/robot-support.png);

    .prompt-example {
        border-left: 3px solid #1C4294;
        background-color: #E1ECFF;
    }
`;

export const ToolItem = styled.div`
    width: 100%;
    max-width: 150px;
    height: 100px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    margin: 0 25px;
`;

export const ToolCategory = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 200px;

    h3 {
        font-family: 'Outfit';
        font-size: 1rem;
        text-transform: uppercase;
        color: #F9F9F9;
        font-weight: 500;
        margin: 0;
        background-color: #212121;
        padding: 5px 10px;
    }
    
    p {
        font-family: 'Outfit';
        font-size: 1rem;
        color: #212121;
        font-weight: 400;
        margin-top: 0.5rem;
        line-height: 1.5;
        margin-bottom: 0;
    }
`;